import apiPricePlans from './../../api/apiPricePlans'

const state = {
    allPricePans: [],
    newPricePlanErrors: {},
    newPricePlan: {
        name: '',
        country: '',
        user_type: '',
        deposit_rate: '',
        deposit: '',
        max_bids: '',
        max_groups: '',
        max_bid_amount: '',
        payment_terms: '',
        payment_due: '',
        roro_fee: '',
        container_fee: '',
        inland_cost: '',
        free_parking: '',
        parking_fee: '',
        lg_fee: '',
        degas: '',
        inspection_japan: '',
        odometer_fix: '',
        late_fee: '',
        negotiation_fee: '',
        local_purchase_fee: '',
        yahoo_fee: '',
        stock_discount: '',
        allocated_credit: '',
    }
}

const getters = {
    getNewPricePlan: (state) => {
        return state.newPricePlan
    },
    getAllPricePlans: (state) => {
        return state.allPricePans
    },
    getNewPricePlanErrors: (state) => {
        return state.newPricePlanErrors
    }
}

const mutations = {
    changeNewPricePlanFieldValue: (state, planInput) => {
        state.newPricePlan[planInput.field] = planInput.value

    },
    setNewPricePlanFieldToDefault: (state) => {
        Object.keys(state.newPricePlan).forEach(function (key) {
            state.newPricePlan[key] = ''
        })
    },
    setAllPricePlans: (state, newValue) => {
        state.allPricePans = newValue
    },
    changeNewPricePlan: (state, newValue) => {
        state.newPricePlan = newValue
    },
    setNewPricePlanErrors: (state, newValue) => {
        state.newPricePlanErrors = newValue
    }
}

const actions = {
    setNewPricePlanFieldValue: ({commit}, planInput) => {
        commit('changeNewPricePlanFieldValue', planInput)
    },
    setNewPricePlan: ({commit}, newValue) => {
        commit('changeNewPricePlan', newValue)
    },
    changeNewPricePlanFieldToDefault: ({commit}) => {
        commit('setNewPricePlanFieldToDefault')
    },
    createNewPricePlan: ({commit, getters}) => {
        commit('setNewPricePlanErrors', {})
        return new Promise((resolve, reject) => {


            apiPricePlans
                .createPricePlanRequest(getters.getNewPricePlan)
                .then((response) => {
                    commit('setNewPricePlanFieldToDefault')
                    resolve();
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response && error.response.status === 422) {
                        reject();
                        commit('setNewPricePlanErrors', JSON.parse(error.response.data))
                    }
                })
        })
    },
    getAllPricePlansRequest: ({commit}) => {
        apiPricePlans
            .pricePlansListRequest()
            .then((response) => {
                commit('setAllPricePlans', response.data)
            })
            .catch((error) => {
                console.log(error)
                if (error.response && error.response.status === 422) {
                    commit('setNewPricePlanErrors', JSON.parse(error.response.data))
                }
            })
    }
}

export default {state, getters, mutations, actions}



// WEBPACK FOOTER //
// ./src/store/modules/pricePalns.js